// extracted by mini-css-extract-plugin
module.exports = {"home_product_category":"CategoryCard_home_product_category__1ooUI","home_product_category_overlay":"CategoryCard_home_product_category_overlay__fNJ05"};